import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import { SearchIcon } from './SearchIcon';
import { SelectClearButton } from "./SelectClearButton";
import { Mask } from "./Mask";
import withTranslator from "../Translator/withTranslation";

const InputContainer = styled.div`
  color: ${({ selected }) => (selected ? colors.blue1 : colors.grey1)};
`;

const LabelContainer = styled.div`
    &:first-letter {
        text-transform:uppercase;
    }
`;
const OptionsContainer = styled.div`
    border-left: 1px solid ;
    border-right: 1px solid ;
    border-bottom: 1px solid ;
    background-color: white;
    position: absolute;
    top: 42px;
    padding-top: 3px;
    color: black;
    max-height: 200px;
    overflow: auto;
    width: 100%;
    z-index: 10;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    padding-bottom:15px;
    box-shadow: 0px 10px 10px -10px;
`;

const OptionsContainerMobile = styled.select`
    width:100%;
    -webkit-appearance:none!important;
    color: ${({ selected }) => (selected ? colors.blue1 : colors.grey1)};
`;

const Option = styled.div`
background-color: white;
padding: 8px;
padding-left: 16px;
cursor: pointer;
&:hover,&.active {
  color: white;
  background-color: ${colors.blue2};
}
&:first-letter {
    text-transform:uppercase;
}
`;

const SelectContainer = styled.div`
    position: relative;
`;

class SelectComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.autocompleteRef = React.createRef();
        this.optionsContainerRef = React.createRef();
        
        this.state = {
            activeElement: false,
            label: null,
            originalOptions: this.props.options ? this.props.options : [],
            autocompleteText: '',
            options: this.props.options,
            scrolled: 0
        };
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);

    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    componentDidUpdate(prevProps){
        if(this.props.options && this.props.options.length > 0 && this.state.originalOptions !== this.props.options){
            this.setState({
                options: this.props.options,
                originalOptions: this.props.options
            });
        }
    }
    
    clear = (value) => {
        this.props.onChange(value);
        
        if(this.props.autocomplete){
            this.autocompleteRef.current.value = ""; 
        }
    }
    
    setWrapperRef = node => {
        this.wrapperRef = node;
    };

    handleClickOutside = event => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ open: false });
        }
    };
    
    handleKeyDown = ( event ) => {
        if(!this.wrapperRef || this.wrapperRef.querySelectorAll('[data-option]').length === 0) return;
                
        var nextElementKey = 0,
            options = this.wrapperRef.querySelectorAll('[data-option]');  
        
        if(!options) return;
        
        if ( event.key === "ArrowDown" || event.key === "ArrowUp") {
            for(var i = 0; i < options.length; i++){
                options[i].classList.remove('active');
            }
        
            if(this.state.activeElement !== false){
                nextElementKey = event.key === "ArrowDown" ? this.state.activeElement + 1 : this.state.activeElement - 1;
            }
            
            if(nextElementKey >= this.wrapperRef.querySelectorAll('[data-option]').length) nextElementKey = 0;
            else if(nextElementKey < 0) nextElementKey = this.wrapperRef.querySelectorAll('[data-option]').length + nextElementKey;
            
            this.wrapperRef.querySelectorAll('[data-option]')[nextElementKey].classList.add('active');
            
            // check scrolling
            const currentOptionY = this.wrapperRef.querySelectorAll('[data-option]')[nextElementKey].getBoundingClientRect().top,
                  currentOptionHeight = this.wrapperRef.querySelectorAll('[data-option]')[nextElementKey].offsetHeight,
                  parentY = this.optionsContainerRef.current.getBoundingClientRect().top + this.optionsContainerRef.current.offsetHeight,
                  parentScrollTop = this.optionsContainerRef.current.scrollTop;
            
            var scrollTo = false;
            
            if((currentOptionY+currentOptionHeight) > parentY){
                scrollTo = this.state.scrolled + currentOptionY;
            } else if(parentScrollTop < currentOptionY && parentScrollTop > 0){
                const offset = (this.optionsContainerRef.current.scrollHeight+parentScrollTop) - currentOptionY;
                
                if(offset >= 0 ){ 
                    scrollTo = currentOptionY - this.state.scrolled;
                }
            }
            
            if(scrollTo){ 
                this.optionsContainerRef.current.scrollTo({
                    top: parseInt(scrollTo),
                    behavior: 'smooth'
                });
                
                this.setState({
                    scrolled: scrollTo
                });
            }

        }
        
        if ( event.key === "Enter" && this.state.activeElement !== false) {
            this.wrapperRef.querySelectorAll('[data-option]')[this.state.activeElement].click();
        }
        
        this.setState({
            activeElement: nextElementKey
        });
    };
    
    onKeyUp = (value) => {
        var autocompleteTriggerLength = this.autocompleteTriggerLength ? this.autocompleteTriggerLength : 3,
            options = [];
        
        this.setState({
            autocompleteText: value.target.value
        });
        
        if(value.target.value.length >= autocompleteTriggerLength){
            if(this.props.autocompleteTriggerURL){
                fetch(this.props.autocompleteTriggerURL+value.target.value)
                    .then(response => response.json())
                    .then(data => {
                        if(data.items){
                            var keySyntax = this.props.autocompleteTriggerKey ? this.props.autocompleteTriggerKey : 'key',
                                labelSyntax = this.props.autocompleteTriggerLabel ? this.props.autocompleteTriggerLabel : 'label';

                            for(var i = 0; i < data.items.length; i++){                             
                                options.push({
                                    'key': data.items[i][keySyntax],
                                    'label': data.items[i][labelSyntax]
                                });
                            } 
                            this.setState({ 
                                open: false
                            }, () => this.setState({
                                options: options
                            }, () => this.setState({ 
                                open: true
                            })));
                        } else {
                            this.setState({ noSuggestion: true });
                        }
                    })
            } else { 
                if(this.state.options.length > 0){
                    for(var i = 0; i < this.state.options.length; i++){
                        if(this.state.options[i].label.toLowerCase().indexOf(value.target.value.toLowerCase()) === 0){
                            options.push(this.state.options[i]);
                        }
                    }
                    this.setState({ 
                        open: false
                    }, () => this.setState({
                        options: options
                    }, () => this.setState({ 
                        open: true
                    })));
                }
            }
        } else {
            if(this.state.options !== this.state.originalOptions){
                const originalOptions = this.state.originalOptions;
                
                this.setState({ 
                    open: false
                }, () => this.setState({
                    options: originalOptions
                }, () => this.setState({ 
                    open: true
                })));
            }
        }
    }
    
    toggle = () => {
        this.setState(state => ({ 
            open: !state.open,
            activeElement: false
        })); 
    };

    select = (value) => {
        this.props.onChange(value);
        this.setState({ open: false });
    };

    render() {
        const { open } = this.state;
        const options = this.state.options ? this.state.options : [];
        const { placeholder, value, id, mobile, t , searchFormVariant } = this.props;
        const selection = options.find(({ key }) => key === value);
        const clear = <SelectClearButton 
                        onChange={(value) => this.clear(value)}
                        clearable={this.props.clearable}
                        offsetRight={this.props.clearOffsetRight ? this.props.clearOffsetRight : null}
                        value={this.props.value}
                    />;          
        const labelText = selection ? selection.label : placeholder; 
        
        var inputValue = selection ? selection.label : (value ? value : this.state.autocompleteText);
        if(inputValue === undefined){ 
            inputValue = this.state.autocompleteText.length > 0 ? this.state.autocompleteText : '';
        }
        const labelContainer = !this.props.autocomplete ? 
                                <LabelContainer>{labelText}</LabelContainer>:
                                <input 
                                id={id ? id : ''}
                                ref={this.autocompleteRef}
                                key="autocomplete"
                                value={inputValue} 
                                placeholder={placeholder} 
                                onChange={(value) => this.onKeyUp(value)}
                                className="btn-no bor-no line-height-inherit font-100 outline-no pad-no width-100 "
                                type="text"
                                />;
        
        let selectElement;

        if(!this.props.mobileNativeSelect && !mobile){
            selectElement = 
                <div key={1} ref={this.setWrapperRef}>
                    <SelectContainer>
                        <InputContainer
                        className={"btn bg-white btn-no margin-no " + (this.props.className ? this.props.className : "") + ( searchFormVariant !== "white" ? " bor-no" : "")}
                        open={open}
                        selected={!!value}
                        onClick={!this.props.autocompleteTriggerURL ? this.toggle : null}
                        mobile={mobile}
                        >
                        <div className="flex items-center relative" onKeyDown={this.handleKeyDown}><SearchIcon src={this.props.iconSrc} show={this.props.withIcon} />{labelContainer}{clear}</div>
                      </InputContainer>
                      {open && (
                        <OptionsContainer ref={this.optionsContainerRef} key="optionsContainerRef">
                            {options.length > 0 ? 
                            options.map(({ key, label }) => (
                              <Option
                                onClick={() => this.select(key)}
                                key={key}
                                mobile={mobile}
                                className="blue1"
                                data-option
                              >
                                {label}
                              </Option>
                            ))
                            :
                            <Option className="grey1">{t('nosuggestions')}</Option>}
                        </OptionsContainer>
                      )}
                    </SelectContainer>
                    {this.props.disabled ?
                    <Mask />
                    :''}
                </div>
        } else {
            selectElement = 
                <div key={1} ref={this.setWrapperRef}>
                    <SelectContainer>
                        <InputContainer mobile={mobile}>
                            <OptionsContainerMobile defaultValue={value ? value : false} onChange={(event) => this.select(event.target.value)} className="btn bg-white bor-white">
                                <option disabled value={false}>{placeholder}</option>
                                {options.map(({ key, label }) => (
                                <option value={key} key={key}>{label}</option>
                                ))}
                            </OptionsContainerMobile>
                        </InputContainer>
                    </SelectContainer>
                </div>
        }

        return selectElement;
      }
}

export const Select = withTranslator(SelectComponent);